import React from 'react'

const CloseIcon = ({ ...props }) => {
  return (
    <svg {...props} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 14'>
      <path d='M13,14a1,1,0,0,1-.71-.29L7,8.41l-5.29,5.3A1,1,0,0,1,.29,12.29L5.59,7,.29,1.71A1,1,0,0,1,1.71.29L7,5.59,12.29.29a1,1,0,1,1,1.42,1.42L8.41,7l5.3,5.29a1,1,0,0,1,0,1.42A1,1,0,0,1,13,14Z' />
    </svg>
  )
}

export default CloseIcon
